import Orthodoxy from './Orthodoxy';

export default Orthodoxy;
